import type { MenuProps } from 'antd';
import type { TableRowActionItem } from '~/app/components/common/TableRowActionsMenu/types';

export function toAntTableRowActionMenuItems(
  items: TableRowActionItem[],
): NonNullable<MenuProps['items']> {
  return items.map(({ onClick: _onClick, ...item }) => item);
}

export function handleTableRowActionMenuClick(
  items: TableRowActionItem[],
): NonNullable<MenuProps['onClick']> {
  return ({ key, domEvent }) => {
    domEvent.stopPropagation();
    const item = items.find((entry) => entry.key === key);
    item?.onClick?.();
  };
}
